module.exports = __webpack_public_path__ + "media/images/coclick-logo-h40-8acd149dafe89c028549a95bbd2c2cce.png";